const AccessionCompleteWarning = ({
  warningList,
  onSubmit,
  onClose,
}: {
  warningList: { id: string; message: string }[];
  onSubmit: () => void;
  onClose: () => void;
}) => {
  return (
    <>
      <h3>Are you sure you want to accession the case?</h3>
      <p>The following case data may require review:</p>
      <ul className="LISForm__errorsList">
        {warningList.map((warning) => (
          <li key={`warning-list-item-${warning.id}`}>{warning.message}</li>
        ))}
      </ul>
      <p>Are you sure this data is correct?</p>
      <footer className="Modal__footer">
        <button className="Button" onClick={onSubmit}>
          Accession Case
        </button>
        <button className="Button" onClick={onClose}>
          Cancel
        </button>
      </footer>
    </>
  );
};

export default AccessionCompleteWarning;
